import { IDosage } from "@curefit/care-common";
import { IMedicinePrescription } from "@curefit/ehr-common";
import TextInput from "../TextInput";
import { MedicineInstructionCodes } from "../../models/Consultation"
import ModelFactory from "../../models/ModelFactory"
import {AppConstants, AppPlaceholders, MedicationTypes} from "../../utils/AppConstants";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import {IAppState} from "../../models/IAppState";
import {MedicationActions} from "../../actions/MedicationActions";
import CustomSelect from "../CustomSelect";
import AppUtils from "../../utils/AppUtils";
import IMedicineSuggestions from "../../models/IMedicineSuggestions";
import * as $ from "jquery";
import * as _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";
// import DosageComponent from "../DosageComponent";
import IMedicineType from "../../models/staticData/IMedicineType";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import DurationComponent from "../DurationComponent";
import MedicationTagsContainer from "../prescription/medicine/MedicationTagsContainer";
import TextAreaAutoResize from "../TextAreaAutoResize";
import { ChangeEvent } from "react" 


/**
 * Created by abhinav on 28/01/18.
 */

export interface ICurrentMedicationItemEditorProps {
    itemIndex?: number,
    consultationType?: string,
    medicationType?: string,
    item: IMedicinePrescription;
    onDataChange: (update: any) => void;
    staticMedicineTypes: IMedicineType[];
    fetchMedicineById: (name: string) => Promise<IMedicineSuggestions[]>;
    fetchMedicineByGenericName: (name: string) => Promise<IMedicineSuggestions[]>;
    fetchDiseaseById: (name: string) => Promise<any>;
}

export interface ICurrentMedicationItemEditorState {
    validate: boolean;
    commonInput: string;
}

class CurrentMedicationItemEditor extends React.Component<ICurrentMedicationItemEditorProps, ICurrentMedicationItemEditorState> {
    private medicationDOM: any;

    constructor(props: ICurrentMedicationItemEditorProps) {
        super(props);
        this.state = {
            validate: false,
            commonInput: ""
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.medicationDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.medicationDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onNameChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = { ...this.props.item, name: event.target.value }
        this.props.onDataChange(updatedItem);
    };

    onGenericNameTypeAheadChange = (input: string) => {
        let updatedItem = { ...this.props.item, name: input.toUpperCase(), code: null as any };
        updatedItem.code = null;
        this.props.onDataChange(updatedItem);
        return this.props.fetchMedicineByGenericName(input.toUpperCase()).then(medicines => {
            let medicineTypeAhead: TypeAheadElement[] = [];
            _.map(medicines, (medicine) => {
                let typeAheadElement: TypeAheadElement = {
                    value: medicine.uCode,
                    label: medicine.productName,
                    additionalInfoLabel: `${medicine.molecule} | ${medicine.dosageForm} | ${medicine.strength}`,
                    others: {
                        dosage: medicine.strength.trim(),
                        genericName: medicine.molecule,
                        type: medicine.dosageForm,
                        available: medicine.expectedInCareFitPharmacy
                    }
                }
                medicineTypeAhead.push(typeAheadElement);
            })
            let availableMedicines = medicineTypeAhead.filter(item => item.others.available);
            let unavailableMedicines = medicineTypeAhead.filter(item => !item.others.available);
            return Promise.resolve({options: availableMedicines.concat(unavailableMedicines), completed: true});
        }).catch(error => {
            throw error;
        });
    };

    onGenericNameTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, name: elem.others.genericName, brand: elem.label };
        // if (this.props.medicationType === MedicationTypes.PRESCRIPTION) {
        updatedItem.code = elem.value;
        updatedItem.dosage = elem.others.dosage;
        let medicineTypeIndex = _.values(this.props.staticMedicineTypes).map(item => item.catalogueCode).indexOf(elem.others.type);
        if (medicineTypeIndex !== -1) updatedItem.medicineType = this.props.staticMedicineTypes[medicineTypeIndex].medicineType;
        else  updatedItem.medicineType = null;
        // }
        this.props.onDataChange(updatedItem);
    }

    onNameTypeAheadChange = (input: string) => {
        let updatedItem = { ...this.props.item, brand: input.toUpperCase(), code: null as any };
        updatedItem.code = null;
        this.props.onDataChange(updatedItem);
        return this.props.fetchMedicineById(input.toUpperCase()).then(medicines => {
            let medicineTypeAhead: TypeAheadElement[] = [];
            _.map(medicines, (medicine) => {
                let typeAheadElement: TypeAheadElement = {
                    value: medicine.uCode,
                    label: medicine.productName,
                    additionalInfoLabel: `${medicine.molecule} | ${medicine.dosageForm} | ${medicine.strength}`,
                    others: {
                        molecule: medicine.molecule,
                        dosage: medicine.strength.trim(),
                        type: medicine.dosageForm,
                        available: medicine.expectedInCareFitPharmacy
                    }
                }
                medicineTypeAhead.push(typeAheadElement);
            })
            let availableMedicines = medicineTypeAhead.filter(item => item.others.available);
            let unavailableMedicines = medicineTypeAhead.filter(item => !item.others.available);
            return Promise.resolve({options: availableMedicines.concat(unavailableMedicines), completed: true});
        }).catch(error => {
            throw error;
        });
    };

    onNameTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, brand: elem.label, name: elem.others.molecule };
        // if (this.props.medicationType === MedicationTypes.PRESCRIPTION) {
        updatedItem.code = elem.value;
        updatedItem.dosage = elem.others.dosage;
        let medicineTypeIndex = _.values(this.props.staticMedicineTypes).map(item => item.catalogueCode).indexOf(elem.others.type);
        if (medicineTypeIndex !== -1) updatedItem.medicineType = this.props.staticMedicineTypes[medicineTypeIndex].medicineType;
        else  updatedItem.medicineType = null;
        // }
        this.props.onDataChange(updatedItem);
    }

    onTroubleTypeAheadChange = (input: string) => {
        let staticDataItem = ModelFactory.createNewStaticItem();
        staticDataItem.displayValue = input;
        let updatedItem = { ...this.props.item, trouble: staticDataItem };
        this.props.onDataChange(updatedItem);
        return this.props.fetchDiseaseById(input).then(diseases => {
            let diseaseTypeAhead: TypeAheadElement[] = [];
            _.map(diseases, (disease: any, index) => {
                let typeAheadElement: TypeAheadElement = {
                    value: disease.id,
                    label: disease.name
                }
                diseaseTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: diseaseTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    }

    onTroubleTypeAheadSelect = (elem: TypeAheadElement) => {
        let trouble = ModelFactory.createNewStaticItem();
        trouble.displayValue = elem.label;
        trouble.internalValue = elem.value;
        let updatedItem = { ...this.props.item, trouble };
        this.props.onDataChange(updatedItem);
    }

    onTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
        let updatedItem = { ...this.props.item, medicineType: event.target.value };
        this.props.onDataChange(updatedItem);
    };

    onMedicineTypeChange = (value: string) => {
        let updatedItem = { ...this.props.item, medicineType: value, code: null as any };
        this.props.onDataChange(updatedItem);
    };

    onFrequencyCountChange = (event: ChangeEvent<HTMLInputElement>): void => {
        let medicineFrequency = this.props.item.medicineFrequency !== null ? this.props.item.medicineFrequency : ModelFactory.createNewMedicineFrequency();
        let medicineFrequencyType = _.isEmpty(medicineFrequency.unit) ? null : medicineFrequency.unit;
        let repeatCount =  isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        medicineFrequency = { ...medicineFrequency, count: repeatCount, unit: medicineFrequencyType};
        let updatedItem = { ...this.props.item, medicineFrequency };
        this.props.onDataChange(updatedItem);
    }

    onFrequencyUnitChange = (value: string): void => {
        let medicineFrequency = this.props.item.medicineFrequency !== null ? this.props.item.medicineFrequency : ModelFactory.createNewMedicineFrequency();
        medicineFrequency = { ...medicineFrequency, unit: value };
        let updatedItem = { ...this.props.item, medicineFrequency };
        this.props.onDataChange(updatedItem);
    }

    onFrequencyChange = (elem: TypeAheadElement) => {
        let medicineFrequency = elem.others.value;
        let updatedItem = { ...this.props.item, medicineFrequency };
        this.props.onDataChange(updatedItem);
    }

    onSinceMonthChange = (value: string): void => {
        let consumingSince = this.props.item.consumingSince !== null && this.props.item.consumingSince !== undefined ? this.props.item.consumingSince : ModelFactory.createNewConsumingSinceObject();
        let consumingSinceYear = _.isEmpty(consumingSince.year) ? null : consumingSince.year;
        let month =  value;
        const consumingSinceVal = { ...consumingSince, month, year: consumingSinceYear};
        let updatedItem = { ...this.props.item, consumingSinceVal };
        this.props.onDataChange(updatedItem);
    }

    onSinceYearChange = (value: string): void => {
        let consumingSince = this.props.item.consumingSince !== null && this.props.item.consumingSince !== undefined ? this.props.item.consumingSince : ModelFactory.createNewConsumingSinceObject();
        consumingSince = { ...consumingSince, year: isNaN(parseInt(value)) ? null : parseInt(value) };
        let updatedItem = { ...this.props.item, consumingSince };
        this.props.onDataChange(updatedItem);
    }

    // onWeekdayChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    //     let weeklySchedule = "";
    //     _.map(event.target.selectedOptions, (option) => {
    //         weeklySchedule = weeklySchedule.concat(`${option.value}-`);
    //     })
    //     weeklySchedule = weeklySchedule.substring(0, weeklySchedule.length - 1);
    //
    //     let medicineFrequency = this.props.item.medicineFrequency !== null ? this.props.item.medicineFrequency : {};
    //     medicineFrequency = { ...medicineFrequency, weeklySchedule };
    //     let updatedItem = { ...this.props.item, medicineFrequency };
    //     this.props.onDataChange(updatedItem);
    // }

    onWeekdayChange = (selectedOptions: string[]) => {
        let weeklySchedule: any[] = [];
        _.map(selectedOptions, (option) => {
            weeklySchedule.push(AppConstants.WeekdaysConstant[option]);
        })

        let medicineFrequency = this.props.item.medicineFrequency !== null ? this.props.item.medicineFrequency : {};
        medicineFrequency = { ...medicineFrequency, weeklySchedule };
        let updatedItem = { ...this.props.item, medicineFrequency };
        this.props.onDataChange(updatedItem);
    }

    onDosageItemChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, dosage: event.target.value, code: null as any };
        updatedItem.code = null;
        this.props.onDataChange(updatedItem);
    }

    onDosageChange = (dosageList: IDosage[]): void => {
        let updatedItem = { ...this.props.item, slotList: dosageList };
        this.props.onDataChange(updatedItem);
    }

    onConditionChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        let updatedItem = { ...this.props.item, intakeCondition: event.target.value };
        this.props.onDataChange(updatedItem);
    }

    onIntakeConditionChange = (value: string): void => {
        let updatedItem = { ...this.props.item, intakeCondition: value };
        this.props.onDataChange(updatedItem);
    }

    onIntakeConditionMultiSelectChange = (selectedOptions: string[]): void => {
        let updatedItem = { ...this.props.item, intakeCondition: {intakeConditionList: selectedOptions} };
        this.props.onDataChange(updatedItem);
    }

    onMedicineDurationCountChange = (event: ChangeEvent<HTMLInputElement>): void => {
        let medicineDuration = _.isEmpty(this.props.item.medicineDuration) ? ModelFactory.createNewMedicineDuration() : this.props.item.medicineDuration;
        let countValue =  isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        let medicineDurationUnit = _.isEmpty(medicineDuration.unit) ? null : medicineDuration.unit;
        const medicineDurationVal = { ...medicineDuration, count: countValue, countDays: countValue, unit: medicineDurationUnit};
        let updatedItem = { ...this.props.item, medicineDurationVal };
        this.props.onDataChange(updatedItem);
    };

    onMedicineDurationSelect = (elem: TypeAheadElement) => {
        let medicineDuration = elem.others.value;
        let updatedItem = { ...this.props.item, medicineDuration };
        this.props.onDataChange(updatedItem);
    }

    onMedicineDurationUnitChange = (value: string): void => {
        let medicineDuration = _.isEmpty(this.props.item.medicineDuration) ? ModelFactory.createNewMedicineDuration() : this.props.item.medicineDuration;
        medicineDuration = { ...medicineDuration, unit: value };
        let updatedItem = { ...this.props.item, medicineDuration };
        this.props.onDataChange(updatedItem);
    }

    onAdditionalInstructionsChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedItem = { ...this.props.item, comment: event.target.value };
        this.props.onDataChange(updatedItem);
    }

    onMedicationReminderChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, remind: event.target.checked }
        this.props.onDataChange(updatedItem);
    }

    onCommonInputTypeAheadChange = (input: string) => {
        this.setState({ commonInput: input })
        if (!isNaN(parseInt(input.trim()))) {
            let count = parseInt(input.trim());
            let frequencySuggestions: TypeAheadElement[] = [];
            _.map(AppConstants.FrequencyUnit, (frequency, key) => {
                let typeAheadElement: TypeAheadElement = {
                    value: key,
                    label: `${count} ${frequency}`,
                    additionalInfoLabel: `Intake Frequency`,
                    others: {
                        type: "frequency",
                        value: { count, unit: key }
                    }
                }
                frequencySuggestions.push(typeAheadElement);
            })
            _.map(AppConstants.FrequencyUnit, (frequency, key) => {
                let typeAheadElement: TypeAheadElement = {
                    value: key,
                    label: `${count} ${frequency}`,
                    additionalInfoLabel: `Duration`,
                    others: {
                        type: "duration",
                        value: { count, unit: key }
                    }
                }
                frequencySuggestions.push(typeAheadElement);
            })
            return Promise.resolve({options: frequencySuggestions, completed: true});
        } else {
            let suggestions: TypeAheadElement[] = [];
            let selectedConditions = !_.isEmpty(this.props.item.intakeCondition) && !_.isEmpty(this.props.item.intakeCondition.intakeConditionList) ? this.props.item.intakeCondition.intakeConditionList : [];
            _.map(Object.keys(MedicineInstructionCodes), (instructionCode, index) => {
                let value = MedicineInstructionCodes[instructionCode];
                if (selectedConditions.indexOf(instructionCode) === -1 && value.toLowerCase().indexOf(input.toLowerCase()) !== -1) {
                    let typeAheadElement: TypeAheadElement = {
                        value: instructionCode,
                        label: value,
                        additionalInfoLabel: `Intake Condition | ${instructionCode}`,
                        others: {
                            type: "intakeCondition",
                            value: instructionCode
                        }
                    }
                    suggestions.push(typeAheadElement);
                }
            })

            let selectedWeekdays = !_.isEmpty(this.props.item.medicineFrequency) && !_.isEmpty(this.props.item.medicineFrequency.weeklySchedule) ? this.props.item.medicineFrequency.weeklySchedule : [];
            _.map(Object.keys(AppConstants.WeekdaysConstant), (weekday, index) => {
                let value = AppConstants.WeekdaysConstant[weekday];
                if (selectedWeekdays.indexOf(weekday) === -1 && value.toLowerCase().startsWith(input.toLowerCase())) {
                    let typeAheadElement: TypeAheadElement = {
                        value: weekday,
                        label: value,
                        additionalInfoLabel: `Weekday`,
                        others: {
                            type: "weekday",
                            value: value
                        }
                    }
                    suggestions.push(typeAheadElement);
                }
            })
            return Promise.resolve({options: suggestions, completed: true});
        }
    }

    onCommonInputTypeAheadSelect = (elem: TypeAheadElement) => {
        let type = elem.others.type;
        if (type === "frequency") {
            let medicineFrequency = elem.others.value;
            let weekdays = !_.isEmpty(this.props.item.medicineFrequency) && !_.isEmpty(this.props.item.medicineFrequency.weeklySchedule) ? this.props.item.medicineFrequency.weeklySchedule : null;
            if (!_.isNull(weekdays)) medicineFrequency.weeklySchedule = weekdays;
            let updatedItem = { ...this.props.item, medicineFrequency };
            this.props.onDataChange(updatedItem);
        } else if (type === "duration") {
            let medicineDuration = elem.others.value;
            let updatedItem = { ...this.props.item, medicineDuration };
            this.props.onDataChange(updatedItem);
        } else if (type === "intakeCondition") {
            let conditions = !_.isEmpty(this.props.item.intakeCondition) && !_.isEmpty(this.props.item.intakeCondition.intakeConditionList) ? this.props.item.intakeCondition.intakeConditionList : [];
            let intakeCondition = conditions;
            intakeCondition.push(elem.others.value);
            let updatedItem = { ...this.props.item, intakeCondition: {intakeConditionList: intakeCondition} };
            this.props.onDataChange(updatedItem);
        } else if (type === "weekday") {
            let medicineFrequency = !_.isEmpty(this.props.item.medicineFrequency) ? this.props.item.medicineFrequency : ModelFactory.createNewMedicineFrequency();
            let weekdays = !_.isEmpty(this.props.item.medicineFrequency) && !_.isEmpty(this.props.item.medicineFrequency.weeklySchedule) ? this.props.item.medicineFrequency.weeklySchedule : [];
            weekdays.push(elem.others.value);
            medicineFrequency.weeklySchedule = weekdays;
            let updatedItem = { ...this.props.item, medicineFrequency };
            this.props.onDataChange(updatedItem);
        }
        this.setState({ commonInput: "" })
    }

    generateMedicineTypeList() {
        let medicineTypeList: IStaticDataValue[] = [];
        _.map(this.props.staticMedicineTypes, (medicineTypeObject, index) => {
            let medicineType = ModelFactory.createNewStaticItem();
            medicineType.internalValue = medicineTypeObject.medicineType;
            medicineType.displayValue = medicineTypeObject.displayText;
            medicineTypeList.push(medicineType);
        })
        return medicineTypeList;
    }

    generateMedicineInstructionsList() {
        let medicineInstructionsList: IStaticDataValue[] = [];
        _.map(MedicineInstructionCodes, (type, key) => {
            let medicineInstruction = ModelFactory.createNewStaticItem();
            medicineInstruction.internalValue = key;
            medicineInstruction.displayValue = type;
            medicineInstructionsList.push(medicineInstruction);
        })
        return medicineInstructionsList;
    }

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    generateMonthItems = (): IStaticDataValue[] => {
        let staticDataValues: IStaticDataValue[] = [];
        _.map(AppConstants.monthsConstant, (month, key) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = key;
            staticDataItem.displayValue = month;
            staticDataValues.push(staticDataItem)
        })
        return staticDataValues;
    }

    generateYearItems = (): IStaticDataValue[] => {
        let staticDataValues: IStaticDataValue[] = [];
        _.map(AppUtils.getYearsArrayFromPatientAge(), (year) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = year.toString();
            staticDataItem.displayValue = year.toString();
            staticDataValues.push(staticDataItem)
        })
        return staticDataValues;
    }

    generateWeekdaysText = (weeklySchedule: string[]): string => {
        let weekdaysText = "";
        _.map(weeklySchedule, (weekday) => {
            weekdaysText = weekdaysText.concat(`${weekday}-`)
        })
        weekdaysText = weekdaysText.slice(0, -1);
        return weekdaysText;
    }

    getMedicineTypeTextFromValue = (medicineType: string) => {
        let index = _.values(this.props.staticMedicineTypes).map(item => item.medicineType).indexOf(medicineType);
        if (index !== -1) return _.values(this.props.staticMedicineTypes).filter(item => item.medicineType === medicineType)[0].displayText;
        else return null;
    }

    generateWeekdaysTags = () => {
        let weekdays = !_.isEmpty(this.props.item.medicineFrequency) && !_.isEmpty(this.props.item.medicineFrequency.weeklySchedule) ?
                        this.props.item.medicineFrequency.weeklySchedule : [];
        let tags: string[] = [];
        _.map(weekdays, (weekday, index) => {
            tags.push(weekday)
        })
        return tags;
    }

    removeWeekday = (index: number) => {
        let weekdays = [ ...this.props.item.medicineFrequency.weeklySchedule];
        weekdays.splice(index, 1);
        let medicineFrequency = this.props.item.medicineFrequency !== null ? this.props.item.medicineFrequency : {};
        medicineFrequency = { ...medicineFrequency, weeklySchedule: weekdays };
        let updatedItem = { ...this.props.item, medicineFrequency };
        this.props.onDataChange(updatedItem);
    }

    generateIntakeConditionsTags = () => {
        let intakeConditions = !_.isEmpty(this.props.item.intakeCondition) && !_.isEmpty(this.props.item.intakeCondition.intakeConditionList) ?
            this.props.item.intakeCondition.intakeConditionList : [];
        let tags: string[] = [];
        _.map(intakeConditions, (condition, index) => {
            tags.push(MedicineInstructionCodes[condition])
        })
        return tags;
    }

    removeIntakeCondition = (index: number) => {
        let intakeConditionList = [ ...this.props.item.intakeCondition.intakeConditionList ];
        intakeConditionList.splice(index, 1);
        let intakeCondition = this.props.item.intakeCondition !== null ? this.props.item.intakeCondition : {};
        intakeCondition = { ...intakeCondition, intakeConditionList };
        let updatedItem = { ...this.props.item, intakeCondition };
        this.props.onDataChange(updatedItem);
    }

    render() {
        let medicineTypeList = this.generateMedicineTypeList();
        let trouble = AppUtils.isDefined(this.props.item.trouble) ? this.props.item.trouble.displayValue : "";
        let medicineInstructionsList = this.generateMedicineInstructionsList();
        let defaultType = AppUtils.isDefined(this.props.item.medicineType) ? this.getMedicineTypeTextFromValue(this.props.item.medicineType) : null;
        let defaultMedicineDurationUnit = AppUtils.isDefined(this.props.item.medicineDuration) ? this.props.item.medicineDuration.unit : null;
        let defaultFrequencyCount: any = AppUtils.isDefined(this.props.item.medicineFrequency) &&
                                            AppUtils.isDefined(this.props.item.medicineFrequency.count) ? this.props.item.medicineFrequency.count.toString() : "" as any;
        let frequencyListItems = this.generateFrequencyListItems();
        let defaultFrequencyUnit = AppUtils.isDefined(this.props.item.medicineFrequency) &&
                                    AppUtils.isDefined(this.props.item.medicineFrequency.unit) ? this.props.item.medicineFrequency.unit : null;
        let defaultSinceMonth: string = AppUtils.isDefined(this.props.item.consumingSince) &&
                                            AppUtils.isDefined(this.props.item.consumingSince.month) ? AppConstants.monthsConstant[this.props.item.consumingSince.month] : null;
        let defaultSinceYear = AppUtils.isDefined(this.props.item.consumingSince) &&
                                    AppUtils.isDefined(this.props.item.consumingSince.year) ? this.props.item.consumingSince.year.toString() : null;
        // let defaultCondition = this.props.item.inTakeCondition !== null ? MedicineInstructionCodes[this.props.item.inTakeCondition] : null;
        let defaultDays: any = _.isEmpty(this.props.item.medicineDuration) ? "" : this.props.item.medicineDuration.count;
        // let weekdayText = this.props.item.medicineFrequency !== null && this.props.item.medicineFrequency.weeklySchedule !== null ?
        //                     this.generateWeekdaysText(this.props.item.medicineFrequency.weeklySchedule) : "";
        // let intakeConditionText = this.props.item.intakeCondition !== null && this.props.item.intakeCondition !== undefined ?
        //                         this.props.item.intakeCondition.intakeConditionList.map(item => MedicineInstructionCodes[item]).join(", ") : "Select";
        // let intakeConditionList = this.props.item.intakeCondition !== null && this.props.item.intakeCondition !== undefined ? this.props.item.intakeCondition.intakeConditionList : [];
        // let isWeekdayInputEnabled = !_.isEmpty(this.props.item.medicineFrequency) &&
        //                             !_.isEmpty(this.props.item.medicineFrequency.unit) &&
        //                             this.props.item.medicineFrequency.unit === "WEEK";
        let medicationType = this.props.medicationType;
        let reminderStatus = this.props.item.remind;
        let genericNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.name) ? "error" : "";
        let brandNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.brand) ? "error" : "";
        let itemIndex = this.props.itemIndex !== undefined ? this.props.itemIndex + "." : "";
        let borderCss = this.props.itemIndex !== undefined ? "highlight-row" : "";

        return (
            <div className={`current-medication-item-editor ${borderCss}`} ref={(medicationDOM) => this.medicationDOM = medicationDOM}>
                <div className="current-medication-editor-count">
                    {itemIndex}
                </div>
                <div className="current-medication-editor-name">
                    <div className={`current-medication-editor-productname ${brandNameValidationStatus}`}>
                        <TypeAhead widgetName={"CurrentMedicationItem"} highlightOn={"available"} name={"medication-name"} value={this.props.item.brand || ""} placeholder={"Product Name"} onTypeAheadChange={this.onNameTypeAheadChange} onTypeAheadSelect={this.onNameTypeAheadSelect}/>
                    </div>
                    <div className={`current-medication-editor-genericname ${genericNameValidationStatus}`}>
                        <TypeAhead widgetName={"CurrentMedicationItem"} highlightOn={"available"} name={"medication-name"} value={this.props.item.name || ""} placeholder={"Generic Name"} onTypeAheadChange={this.onGenericNameTypeAheadChange} onTypeAheadSelect={this.onGenericNameTypeAheadSelect}/>
                    </div>
                </div>
                <div className="current-medication-editor-type">
                    <CustomSelect capitalizeInput={true} dropdownValues={medicineTypeList} selectedValue={defaultType} defaultValue={"Type"} updateDropdownValue={this.onMedicineTypeChange}/>
                </div>
                <div className="current-medication-editor-dosage">
                    <TextInput name="medicine-dosage" value={this.props.item.dosage || ""} onChange={this.onDosageItemChange} placeholder={AppPlaceholders.CURRENT_MEDICATION_EDITVIEW_DOSAGE}/>
                </div>
                {
                    medicationType === MedicationTypes.ACTIVE &&
                    <div className="current-medication-editor-disease">
                        <TypeAhead widgetName={"CurrentMedicationItem"} name={"medication-condition"} value={trouble} placeholder={"Condition"} onTypeAheadChange={this.onTroubleTypeAheadChange} onTypeAheadSelect={this.onTroubleTypeAheadSelect}/>
                    </div>
                }
                <div className="current-medication-editor-at">
                    {/* <DosageComponent dosageList={this.props.item.slotList} onDataChange={this.onDosageChange} /> */}
                </div>
                <div className="current-medication-editor-frequency">
                    <DurationComponent isFrequency={true} unit={defaultFrequencyUnit} count={defaultFrequencyCount}
                                       dropdownItems={this.generateFrequencyListItems()} rootClass={"medication-frequency"}
                                       onCountChange={this.onFrequencyCountChange} onUnitChange={this.onFrequencyUnitChange}
                                       onDurationChange={this.onFrequencyChange}/>

                </div>
                {/*{
                    medicationType === MedicationTypes.PRESCRIPTION &&
                    <div className="current-medication-editor-weekdays">
                        <MultiSelectDropdown items={AppConstants.WeekdaysConstant} onChangeHandler={this.onWeekdayChange} textValue={weekdayText} disabled={!isWeekdayInputEnabled}/>
                    </div>
                }*/}
                {
                    medicationType === MedicationTypes.PRESCRIPTION &&
                    <div className="current-medication-editor-duration">
                        <DurationComponent unit={defaultMedicineDurationUnit} count={defaultDays}
                                           dropdownItems={this.generateFrequencyListItems()} rootClass={"medication-duration"}
                                           onCountChange={this.onMedicineDurationCountChange} onUnitChange={this.onMedicineDurationUnitChange}
                                           onDurationChange={this.onMedicineDurationSelect}/>
                    </div>
                }

                {
                    medicationType === MedicationTypes.ACTIVE &&
                    <div className="current-medication-editor-since">
                        <div className="medication-since-count">
                            <CustomSelect dropdownValues={this.generateMonthItems()} selectedValue={defaultSinceMonth} defaultValue={"Month"} updateDropdownValue={this.onSinceMonthChange}/>
                        </div>
                        <div className="medication-since-unit">
                            <CustomSelect dropdownValues={this.generateYearItems()} selectedValue={defaultSinceYear} defaultValue={"Year"} updateDropdownValue={this.onSinceYearChange}/>
                        </div>
                    </div>
                }
                {/*{
                    medicationType === MedicationTypes.PRESCRIPTION &&
                    <div className="current-medication-editor-condition">
                        <CustomSelect dropdownValues={medicineInstructionsList} selectedValue={defaultCondition} defaultValue={"Select"} updateDropdownValue={this.onIntakeConditionChange}/>
                        <MultiSelectDropdown items={MedicineInstructionCodes} onChangeHandler={this.onIntakeConditionMultiSelectChange} textValue={intakeConditionText} selectedItems={intakeConditionList}/>
                    </div>
                }*/}
                <br/>
                <br/>
                <div className="current-medication-editor-tags">
                    {
                        this.generateWeekdaysTags().length > 0 &&
                        <div className={"weekdays-tags-container"}>
                            <MedicationTagsContainer tags={this.generateWeekdaysTags()} onCancelHandler={this.removeWeekday} hideCancelButton={false} />
                        </div>
                    }
                    {
                        this.generateIntakeConditionsTags().length > 0 &&
                        <div className={"intake-condition-tags-container"}>
                            <MedicationTagsContainer tags={this.generateIntakeConditionsTags()} onCancelHandler={this.removeIntakeCondition} hideCancelButton={false} />
                        </div>
                    }
                </div>
                {
                    medicationType === MedicationTypes.PRESCRIPTION &&
                    <div className="current-medication-editor-common-input">
                        <TypeAhead widgetName={"CurrentMedicationItem"} name={"common-input"} value={this.state.commonInput || ""} placeholder={"Start typing"} onTypeAheadChange={this.onCommonInputTypeAheadChange} onTypeAheadSelect={this.onCommonInputTypeAheadSelect}/>
                    </div>
                }
                <br/>
                <br/>
                <div className="current-medication-editor-comment">
                    <TextAreaAutoResize
                        name={"current-medication-editor-comment"}
                        className={"textarea-input form-control"}
                        value={this.props.item.comment || ""}
                        onChange={this.onAdditionalInstructionsChange}
                        placeholder={AppPlaceholders.CURRENT_MEDICATION_EDITVIEW_COMMENT}
                        rows={2}
                    />
                </div>
                {
                    medicationType === MedicationTypes.PRESCRIPTION && this.props.consultationType === AppConstants.ConsultationTypes.KMH &&
                    <div className="current-medication-editor-reminder">
                        <input type="checkbox" onChange={this.onMedicationReminderChange} checked={reminderStatus} />
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {}
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchMedicineById: (input: string) => {
            return MedicationActions.loadMedicines(input);
        },
        fetchMedicineByGenericName: (input: string) => {
            return MedicationActions.loadMedicinesByGenericName(input);
        },
        fetchDiseaseById: (input: string) => {
            return MedicationActions.loadDiseases(input);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentMedicationItemEditor);
